export default __webpack_public_path__ + "static/media/Contrend-logo-red.307c78e6.png";